import { useApolloClient } from '@apollo/client'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import {
  useEffect,
  useState,
} from 'react'

import { Page } from '@Generated/graphql'
import FacetDescriptionQuery from '@Queries/facetDescription/facetDescription.query'

interface UseFacetDescriptionProps {
  openModal: boolean
  pageIDs: string[]
}

export const useFacetDescription = ({ openModal, pageIDs }: UseFacetDescriptionProps): Page[] => {
  const [pages, setPages] = useState<Page[]>([])
  const client = useApolloClient()

  useEffect(() => {
    if (!openModal || isEmpty(pageIDs)) {
      setPages([])
      return
    }
    (async () => {
      const dataPages = await Promise.all(pageIDs.map(key => client.query<{ page: Page }>({
        query: FacetDescriptionQuery,
        variables: {
          id: key,
        },
      })))
      setPages(map(dataPages, dataPage => dataPage.data.page))
    })()
  }, [client, pageIDs, openModal])
  return pages
}
